import { TFunction } from "react-i18next";
import i18n from 'i18next';
import { Candidate, CandidateSimple } from "../../../../models/candidate.model";
import { toTitleCase } from "../../../../utils/string.utils";
import { formatCurrencyNoDecimal } from "../../../../utils/currency.utils";

export const getCandidatePosition = (
    current_page: number | undefined, 
    page_size: number | undefined, 
    key: number
) => {
    return ((current_page ?? 1) - 1) * (page_size ?? 10) + (key + 1);
};

export const getCandidateHireModel = (candidate: Candidate | CandidateSimple, t: TFunction) => {
    const { remote, work_model_presencial, work_model_hybrid } = candidate;
    const root = (key: string) => t(`talent.${key}`);
    const options: string[] = [];
    
    remote && options.push(root('remoteWork'));
    work_model_presencial && options.push(root('presentialWork'));
    work_model_hybrid && options.push(root('hybridWork'));

    return options.length ? options.join('/') : '-';
};

export const getCandidateHireTypes = (candidate: Candidate | CandidateSimple) => {
    return candidate.hire_types &&
        candidate.hire_types.length > 0 &&
        candidate.hire_types.map((ht) => ht.name).join('/');
};

export const getCandidateSalary = (candidate: Candidate | CandidateSimple, t: TFunction) => {
    const salary = formatCurrencyNoDecimal(Number(candidate.wage_claim), candidate.wage_claim_currency, i18n.language);
    return salary ? t('ranking-table.salary', {salary: salary}) : '';
};

export const getMainSkills = (candidate: Candidate, t: TFunction) => {
    return candidate.main_skills &&
        candidate.main_skills.length > 0 &&
        candidate.main_skills
            .map((main_skill) => t(toTitleCase(main_skill.name))).join('/');
};
